const StatCard = ({ label, value, icon: Icon }) => (
  <div className="dashboard-stat-card">
    {Icon && <Icon className="dashboard-stat-card__icon" aria-hidden="true" />}
    <p className="dashboard-stat-card__label">{label}</p>
    <p className="dashboard-stat-card__value">{value}</p>
  </div>
);

export default StatCard;
